/**
 * Base URL for the reseller BFF. Empty string (the default) means "same
 * origin, relative `/api/...`" — the normal case, since Vite/`vite preview`
 * proxy `/api` to the server (see vite.config.ts) and production sits both
 * apps behind one reverse proxy. Set `VITE_RESELLER_API_URL` only for a
 * build that must call a BFF on a different origin (e.g. the prod build
 * step, mirroring xop-edge-staff's `VITE_DASHBOARD_API_URL`).
 */
export const env = {
  apiUrl: import.meta.env.VITE_RESELLER_API_URL ?? "",
};
